import { render } from "./Essenza.vue?vue&type=template&id=663178a0&scoped=true"
import script from "./Essenza.vue?vue&type=script&lang=js"
export * from "./Essenza.vue?vue&type=script&lang=js"

import "./Essenza.vue?vue&type=style&index=0&id=663178a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-663178a0"

export default script